import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { needToRedirectToParticipantPage } from './needToRedirectToParticipantPage';
import { needToRedirectBackToVisitorPage } from './needToRedirectBackToVisitorPage';
import { goToParticipantPage } from './goToParticipantPage';
import { goToVisitorPage } from './goToVisitorPage';

export const isRedirectingToVisitorOrParticipantPage = async ({
  initialProps,
  flowAPI,
}: {
  initialProps: any;
  flowAPI: ControllerFlowAPI;
}) => {
  // logged in, public / private & approved, already joined
  if (await needToRedirectToParticipantPage({ initialProps, flowAPI })) {
    flowAPI.controllerConfig.setProps({
      isForcedBlankPage: true,
    });

    goToParticipantPage({
      challengeData: initialProps.challengeData,
      flowAPI,
    });
    return true;
  }

  // private program, waiting for owners approval
  if (needToRedirectBackToVisitorPage({ initialProps, flowAPI })) {
    flowAPI.controllerConfig.setProps({
      isForcedBlankPage: true,
    });

    goToVisitorPage({
      challengeData: initialProps.challengeData,
      flowAPI,
    });
    return true;
  }

  return false;
};
